import React from 'react';

// Components import
import { HeaderContainer, LogoHeader, MenuIcon, NavContainer, NavItem, NavLink, NavMenu, SocialIcons, SubItem, SubNav } from './NavStyles';
import { ArrowDown, FaceIcon, InstaIcon, WhatsIcon } from 'src/styles/DesignSystem';

import logo from 'src/assets/logo.png';
import { Link } from 'react-router-dom';

const Navbar = ({ toggle, page }) => {
    
    return (
        <HeaderContainer>
            <LogoHeader>
                <Link to="/">
                    <img src={logo} alt="Hipermercado das Rações" />
                </Link>
                
            </LogoHeader>

            <MenuIcon onClick={toggle} >
                <div />
                <div />
                <div />
            </MenuIcon>

            <NavContainer>
                <NavMenu>
                    <NavItem className={page ==='home' && "active" }>
                        <NavLink to="/" smooth={true}>Home</NavLink>
                    </NavItem>

                    <NavItem className={page ==='institucional' && "active" }>
                        <NavLink to="/institucional" smooth={true}>Institucional</NavLink>
                    </NavItem>

                    <NavItem className={page ==='servicos' && "active" }>
                        <NavLink to="#" smooth={true}>Serviços</NavLink>
                        <SubNav>
                            <ArrowDown />
                            <SubItem>
                                <NavLink to="/servicos/clinica-veterinaria" state={{ id: 19 }}>Clínica veterinaria</NavLink>
                            </SubItem>

                            <SubItem>
                                <NavLink to="/servicos/banho-e-tosa"  state={{ id: 54 }}>Banho e tosa</NavLink>
                            </SubItem>

                            <SubItem>
                                <NavLink to="/servicos/loja"  state={{ id: 55 }}>Loja</NavLink>
                            </SubItem>
                        </SubNav>
                    </NavItem>

                    <NavItem className={page ==='contato' && "active" }>
                        <NavLink to="/contato" smooth={true}>Contato</NavLink>
                    </NavItem>
                </NavMenu>
            </NavContainer>

            <SocialIcons>
                <a href="https://www.facebook.com/"><FaceIcon /></a>
                <a href="https://www.instagram.com/hiperdasracoes/"><InstaIcon /></a>
                <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&app_absent=0"><WhatsIcon /></a>
            </SocialIcons>
        </HeaderContainer>
    )
}

export default Navbar;